import { MenuServiceTime } from 'scbk-services/types/menu/menu';

const getText = (el: Element | null) => el?.textContent?.trim() ?? '';

/**
 * 메뉴 서비스 이용시간 로더 클래스
 */
export class MenuServiceTimeLoader {
    /**
     * 메뉴 서비스 이용시간을 로드한다.
     * @returns
     */
    public async load(raw: string): Promise<Record<string, MenuServiceTime>> {
        return this.parseServiceTimeList(raw);
    }

    /**
     * 메뉴 서비스 이용시간을 파싱한다.
     * @param raw 메뉴 서비스 이용시간 원본 xml 문자열
     * @returns
     */
    private parseServiceTimeList(raw: string): Record<string, MenuServiceTime> {
        const parser = new DOMParser();
        const xml = parser.parseFromString(raw, 'text/xml');

        const nodes = xml.querySelectorAll('service-time-list > service-time');

        const serviceTimes: Record<string, MenuServiceTime> = {};

        Array.from(nodes).forEach((el) => {
            const serviceTime = this.parseServiceTime(el);
            serviceTimes[serviceTime.id] = serviceTime;
        });
        return serviceTimes;
    }

    /**
     * 개별 서비스 이용시간 정보를 파싱한다.
     * @param node 개별 이용시간정보 Element
     * @returns
     */
    private parseServiceTime(node: Element): MenuServiceTime {
        const id = node.getAttribute('code') ?? '';
        const checkYn = (node.getAttribute('checkYn') as 'Y' | 'N') ?? 'N';
        const nextPage = node.getAttribute('nextPage') ?? '';
        const nextPageParameter = node.getAttribute('nextPageParameter') ?? '';
        const startTime = getText(node.querySelector('start-time'));
        const endTime = getText(node.querySelector('start-time'));

        return {
            id,
            checkYn,
            nextPage,
            nextPageParameter,
            startTime,
            endTime,
        };
    }
}
